import { Popup } from "components/UI/Popup";
import { Fragment, useCallback, useMemo, useState } from "react";
import { Link, useLocation, useSearchParams } from "react-router-dom";
import { routes } from "routes";
import classes from "./ChangedEmailPopup.module.scss";

const SUCCESS_CHANGED = "Email Changed!";
const ERROR_CHANGED = "Email change failed";

const ERROR_VERIFIED = "Unsuccessful Email Verified!";
const SUCCESS_VERIFIED = "Email Verified!";

const SUCCESS_RESET_PASSWORD = "Password Changed!";
const ERROR_RESET_PASSWORD = "Password change failed";

const SuccessMessage = () => {
  return (
    <Fragment>
      <p>Congrats, you did it.</p>
      <p>
        Your account is now secure, and you will now receive key account
        notifications via email.
      </p>
      <p>
        If you want to change your email address, you can do so in your
        &nbsp;
        <Link to={routes.accountSettings()}>account settings</Link>.
      </p>
    </Fragment>
  );
};

export const ChangedEmailPopup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();

  const message = useMemo(() => {
    const value = searchParams.get("message");
    setIsOpen(!!value);
    return value;
  }, [searchParams]);

  const handleClose = useCallback(() => {
    setIsOpen(false);
    setSearchParams([]);
  }, [setSearchParams]);

  const title = useMemo(() => {
    if (message === null) {
      return "";
    }

    if (message === "email-changed") {
      return SUCCESS_CHANGED;
    }

    if (message === "email-change-taken" || message === "email-change-error") {
      return ERROR_CHANGED;
    }

    if (location.hash === "#verify-email") {
      if (searchParams.get("code") === "already-verified") {
        return SUCCESS_VERIFIED;
      }

      return searchParams.get("success") === "true" ? SUCCESS_VERIFIED : ERROR_VERIFIED;
    }

    if (location.hash === "#reset-password") {
      return searchParams.get("success") === "true" ? SUCCESS_RESET_PASSWORD : ERROR_RESET_PASSWORD;
    }

    if (location.hash === "#changed-email") {
      return searchParams.get("success") === "true" ? SUCCESS_CHANGED : ERROR_CHANGED;
    }

    return "";
  }, [location.hash, message, searchParams]);

  const description = useMemo(() => {
    if (message === null) {
      return "";
    }

    if (message === "email-changed") {
      return (<SuccessMessage />);
    }

    if (message === "email-change-taken") {
      return "The email address is already taken.";
    }

    if (message === "email-change-error") {
      return "The email address could not be changed. Please try again later.";
    }

    if (location.hash === "#verify-email" || location.hash === "#changed-email") {
      if (searchParams.get("code") === "already-verified") {
        return (<SuccessMessage />);
      }

      return searchParams.get("success") === "true" ? (<SuccessMessage />) : message;
    }

    return message;
  }, [location.hash, message, searchParams]);

  return (
    <Popup
      isOpen={isOpen}
      onClose={handleClose}
      title={title}
    >
      <div className={classes.content}>
        {description}
      </div>
    </Popup>
  );
};
